module.exports = __webpack_public_path__ + "static/media/virus_image.a985e79f.jpg";